import React from 'react';
import { useNavigate } from 'react-router-dom';
import Table from '../components/Table';
import { useDeleteSAssignmentMutation, useGetAllAssignmentQuery } from '../features/assignment/assignmentApi';

const Assignment = () => {
  
  const tableHead=['Title','Video Title','Mark','Action'];

  const {data:assignmentList,isSuccess,isError,isLoading,error}=useGetAllAssignmentQuery();
  const[deleteAssignment, {}]=useDeleteSAssignmentMutation();



 const tableKeyNames=['title','video_title','totalMark'];
 const navigate=useNavigate();

 const handleEdit=(id)=>{
navigate(`/admin/assignment/edit/${id}`)
 }

 const handleDelete=(id)=>{
  deleteAssignment(id)
 }

  return (
    <>
   <section className="py-6 bg-primary">
  <div className="mx-auto max-w-full px-5 lg:px-20">
    <div className="px-3 py-20 bg-opacity-10">
      <div className="w-full flex">
        <button className="btn ml-auto" onClick={()=>navigate('/admin/assignment/add')}>Add Assignment</button>
      </div>
     

<Table handleEdit={handleEdit} handleDelete={handleDelete} tableHead={tableHead} data={assignmentList} tableKeyNames={tableKeyNames} showDelete={true}  showEdit={true} isSuccess={isSuccess} isError={isError} isLoading={isLoading}/>

    </div>
  </div>
</section>

    </>
  )
}

export default Assignment